module.exports = __webpack_public_path__ + "img/platinum.bb28d00f.png";